<template>
  <div class="app flex-row align-items-center">
    <div class="container animated zoomIn">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card class="p-2" no-body>
              <b-card-body>
                <b-form @keyup.enter="trigger">

                  <b-row align-h="around" class="p-3">
                    <b-col cols="10">
                      <b-img src="img/full-logo.png" fluid />
                    </b-col>
                  </b-row>

                  <h2>Bienvenido</h2>

                  <p class="text-muted">Por favor inicia sesión.</p>

                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-model="login.username" type="text" class="form-control"
                      placeholder="Usuario" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-model="login.password" type="password" class="form-control" placeholder="Contraseña"
                      autocomplete="current-password" />
                  </b-input-group>
                  <b-row align-h="end">
                    <!-- <b-col cols="6" class="text-right">
<b-button variant="link" class="px-0">Forgot password?</b-button>
</b-col> -->
                    <b-col cols="5" md="12">
                      <b-button block variant="primary" class="px-4" @click="trigger()">Iniciar sesión</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {
    mapActions, mapGetters
  } from 'vuex'
  import router from '@/router/index.js'
  export default {
    data: () => {
      return {
        login: {}
      }
    },
    name: 'Login',
    computed: {
      ...mapGetters(['authGetUser'])
    },
    methods: {
      ...mapActions(['authTryLogin']),
      trigger() {
        this.authTryLogin(this.login).then(() => {
          switch(this.authGetUser.tipoUsuario){
            case 'Restaurant':
              router.push('/nutricion/recetas/index')
              break;
            default:
              router.push('/compras')
              break;
          }
        })
      }
    }

  }

</script>
